import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BuyContractService } from '../buy-contract.service';
import { BuyContractAllocation } from '../buy-contract.type';
import { AllocationGroupsList } from '../allocation-groups-list/allocation-groups-list';

export interface BuyContractAllocationsDialogData {
  contractId: string;
}

@Component({
  selector: 'app-buy-contract-allocations-dialog',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    AllocationGroupsList,
  ],
  templateUrl: './buy-contract-allocations-dialog.html',
  styleUrl: './buy-contract-allocations-dialog.scss'
})
export class BuyContractAllocationsDialog implements OnInit {
  allocations: BuyContractAllocation[] = [];
  loading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: BuyContractAllocationsDialogData,
    private dialogRef: MatDialogRef<BuyContractAllocationsDialog>,
    private service: BuyContractService,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.service.getBuyContractAllocations(this.data.contractId).subscribe({
      next: res => {
        this.allocations = res.items;
        this.loading = false;
      },
      error: () => {
        this.snackBar.open('Error loading allocations', 'Close', { duration: 5000 });
        this.loading = false;
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
